import React from "react";

import SourcesListPanel from "./SourcesListPanel";
import IssbContainer from "../IssbContainer";


export default function SourcesListPage({ HackBelow, showFiles }) {
	return (
		<IssbContainer>
			<SourcesListPanel HackBelow={HackBelow} showFiles={showFiles} />
		</IssbContainer>
	);
};

